import { useQuery } from "@tanstack/react-query";
import type { UserInfo } from "../../types";
import { userService } from "../../services/userService";

export const useUsers = () => {
  return useQuery<UserInfo[]>({
    queryKey: ["users"],
    queryFn: async () => await userService.list()
  });
};
